
      // Manage service worker: register only in production, unregister in dev to avoid caching issues
      if (import.meta && import.meta.env && import.meta.env.MODE === 'production') {
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/service-worker.js');
        }
      } else {
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then((regs) => {
            regs.forEach((r) => r.unregister());
          });
        }
      }
    